import React, { useCallback, useState } from 'react';
import ItemCategoryFilter from '@/components/filters/ItemCategoryFilter';
import { ResidentialUnitDocumentSearchOptions } from '@/services/documents';
import { Trans } from '@lingui/react/macro';
import { FilterButtons, FilterPopOut, useIsFilterModified } from '@ygtechnologies/bygr-frontend-component-library';

interface DocumentsFilterProps {
    filter: ResidentialUnitDocumentSearchOptions;
    defaultFilter: ResidentialUnitDocumentSearchOptions;
    onChange(f: ResidentialUnitDocumentSearchOptions): void;
}

const DocumentsFilter: React.FC<DocumentsFilterProps> = ({ filter, defaultFilter, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const getDefaultFilter = useCallback(() => {
        return defaultFilter;
    }, [defaultFilter]);

    const filterModified = useIsFilterModified(filter, getDefaultFilter);

    const handleClear = () => {
        onChange(defaultFilter);
    };

    return (
        <>
            <FilterButtons onButtonClick={() => setIsOpen(!isOpen)} isActive={filterModified}></FilterButtons>
            <FilterPopOut onClear={handleClear} onClose={() => setIsOpen(false)} isVisible={isOpen}>
                <label className="filter-label">
                    <Trans>Categories</Trans>
                </label>
                <ItemCategoryFilter onChange={(v) => onChange({ ...filter, categories: v })} value={filter.categories!} />
            </FilterPopOut>
        </>
    );
};

export default DocumentsFilter;
